import script from "./SuperMario.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuperMario.vue?vue&type=script&lang=ts&setup=true"

import "./SuperMario.vue?vue&type=style&index=0&id=2cc7e1d2&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc7e1d2"]])

export default __exports__